/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VersionsPostRequest
 */
export interface VersionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof VersionsPostRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof VersionsPostRequest
     */
    platform: string;
    /**
     * 
     * @type {any}
     * @memberof VersionsPostRequest
     */
    data?: any | null;
}

/**
 * Check if a given object implements the VersionsPostRequest interface.
 */
export function instanceOfVersionsPostRequest(value: object): value is VersionsPostRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function VersionsPostRequestFromJSON(json: any): VersionsPostRequest {
    return VersionsPostRequestFromJSONTyped(json, false);
}

export function VersionsPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionsPostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'platform': json['platform'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function VersionsPostRequestToJSON(json: any): VersionsPostRequest {
    return VersionsPostRequestToJSONTyped(json, false);
}

export function VersionsPostRequestToJSONTyped(value?: VersionsPostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'platform': value['platform'],
        'data': value['data'],
    };
}

